/**
 * Event Types
 *
 * Defines all event types emitted by the AlphaLend protocol:
 * - Supply, borrow, withdraw, and repay events
 * - Liquidation events
 * - Interest rate update events
 * - Protocol parameter change events
 * - Market-related events (creation, closure, pause)
 * - Type definitions for event parsing and handling
 */
